import React from 'react';
import './styles.scss';

const CounterInput = (props) => {
  const { value, label, handleCounterChange, isRounder = false, minValue } = props;

  return (
    <>
      {label && <label>{label}</label>}
      <div className={`counter ${isRounder ? 'rounded-counter' : ''}`}>
        {value > minValue ? (
          <button className="counter-control" onClick={() => handleCounterChange(value - 1, 'sub')} type="button">
            -
          </button>
        ) : null}
        <span>{value}</span>
        <button
          className="counter-control"
          onClick={() => {
            handleCounterChange(value + 1, 'add');
          }}
          type="button"
        >
          +
        </button>
      </div>
    </>
  );
};

export default CounterInput;
